import {useColorMode} from '@chakra-ui/react';
import {faMoon} from '@fortawesome/pro-light-svg-icons/faMoon';
import {faSun} from '@fortawesome/pro-light-svg-icons/faSun';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useRef} from 'react';

import type {SwitchProps} from '../Switch';
import {Switch} from '../Switch';

export type ToggleColorModeProps = SwitchProps;
export const ToggleColorMode = (props: ToggleColorModeProps) => {
  const {colorMode, setColorMode} = useColorMode();
  const ref = useRef<HTMLElement | null>(null);

  return (
    <Switch
      onChange={e => {
        setColorMode(e.target.checked ? `light` : `dark`);
      }}
      display={`flex`}
      alignItems={`center`}
      transition={`all 0.2s`}
      ref={ref}
      isChecked={colorMode === `light`}
      {...props}
    >
      <FontAwesomeIcon alignmentBaseline={`baseline`} size={`sm`} icon={colorMode === `light` ? faSun : faMoon} />
    </Switch>
  );
};
